import { baseTree } from "@/constants/data-test-ids/components/base-tree-data-test-ids";
import { confirmationDialog } from "@/constants/data-test-ids/components/confirmation-dialog-data-test-ids";
import { consumptionOverviewSites } from "@/constants/data-test-ids/components/consumption-overview-sites-data-table-data-test-ids";
import { selectSiteSectionPerimeter } from "@/constants/data-test-ids/components/consumption/select-site-section-perimeter-data-test-ids";
import { siteConsumptionMonitoringSectionCategoryFilter } from "@/constants/data-test-ids/components/consumption/site-consumption-monitoring-section-category-filter-data-test-ids";
import { dateRangePicker } from "@/constants/data-test-ids/components/date-range-picker-data-test-ids";
import { planningDateRangeHeaderCell } from "@/constants/data-test-ids/components/planning/planning-date-range-header-cell-data-test-ids";
import { planningDateRangeNavigator } from "@/constants/data-test-ids/components/planning/planning-date-range-navigator-data-test-ids";
import { planningTodayHeaderCell } from "@/constants/data-test-ids/components/planning/planning-today-header-cell-data-test-ids";
import { programmingDateRangeInputs } from "@/constants/data-test-ids/components/planning/programming-date-range-inputs-data-test-ids";
import { programmingRangeFormDialog } from "@/constants/data-test-ids/components/planning/programming-range-form-dialog-data-test-ids";
import { sectionChildrenProgrammingRangesCountCell } from "@/constants/data-test-ids/components/planning/section-children-programming-ranges-count-cell-data-test-ids";
import { sectionProgrammingRange } from "@/constants/data-test-ids/components/planning/section-programming-range-data-test-ids";
import { sectionProgrammingRangesCell } from "@/constants/data-test-ids/components/planning/section-programming-ranges-cell-data-test-ids";
import { programEditor } from "@/constants/data-test-ids/components/program-editor-data-test-ids";
import { programFormDialog } from "@/constants/data-test-ids/components/programming/program-form-dialog-data-test-ids";
import { programIcon } from "@/constants/data-test-ids/components/programming/program-icon-data-test-ids";
import { weeklyProgram } from "@/constants/data-test-ids/components/programming/weekly-program-data-test-ids";
import { categoryCreationForm } from "@/constants/data-test-ids/components/section/category-creation-form-data-test-ids";
import { createSiteSectionDrawer } from "@/constants/data-test-ids/components/section/create-site-section-drawer-data-test-ids";
import { editSiteDetailsDrawer } from "@/constants/data-test-ids/components/section/edit-site-details-drawer-data-test-ids";
import { editSiteDetailsForm } from "@/constants/data-test-ids/components/section/edit-site-details-form-data-test-ids";
import { moveSectionAppliancesWizard } from "@/constants/data-test-ids/components/section/move-section-appliances-wizard-data-test-ids";
import { sectionAppliancesCountByProgrammingCategory } from "@/constants/data-test-ids/components/section/section-appliances-count-by-programming-category-data-test-ids";
import { sectionAppliancesV2Dialog } from "@/constants/data-test-ids/components/section/section-appliances-v2-dialog-data-test-ids";
import { sectionDetailsDrawer } from "@/constants/data-test-ids/components/section/section-details-drawer-data-test-ids";
import { sectionDetailsReadonlyContent } from "@/constants/data-test-ids/components/section/section-details-readonly-content-data-test-ids";
import { selectSectionParentDialog } from "@/constants/data-test-ids/components/section/select-section-parent-dialog-data-test-ids";
import { simpleSiteSectionsTree } from "@/constants/data-test-ids/components/section/simple-site-sections-tree-data-test-ids";
import { siteDetailsCard } from "@/constants/data-test-ids/components/section/site-details-card-data-test-ids";
import { siteSectionActiveFilters } from "@/constants/data-test-ids/components/section/site-section-active-filters-data-test-ids";
import { siteSectionCategoryDrawer } from "@/constants/data-test-ids/components/section/site-section-category-drawer-data-test-ids";
import { siteSectionsTreeApplianceCategoryFilter } from "@/constants/data-test-ids/components/section/site-sections-tree-appliance-category-filter-data-test-ids";
import { siteSectionsTreeSectionCategoryFilter } from "@/constants/data-test-ids/components/section/site-sections-tree-section-category-filter-data-test-ids";
import { selectProgram } from "@/constants/data-test-ids/components/select-program-data-test-ids";
import { selectSite } from "@/constants/data-test-ids/components/select-site-data-test-ids";
import { draggableSiteSectionsTree } from "@/constants/data-test-ids/components/site/draggable-site-sections-tree-data-test-ids";
import { siteSectionsVirtualizedTable } from "@/constants/data-test-ids/components/site/site-sections-virtualized-table-data-test-ids";
import { siteTreeStructure } from "@/constants/data-test-ids/components/site/site-tree-structure-data-test-ids";
import { tabs } from "@/constants/data-test-ids/components/tabs-data-test-ids";
import { userPerimeterTree } from "@/constants/data-test-ids/components/user-perimeter-tree-data-test-ids";
import { consumptionMonitoring } from "@/constants/data-test-ids/views/consumption-monitoring-data-test-ids";
import { siteSectionsPlanning } from "@/constants/data-test-ids/views/control/site-sections-planning-data-test-ids";
import { dashboard } from "@/constants/data-test-ids/views/dashboard-data-test-ids";
import { siteConsumptionMonitoring } from "@/constants/data-test-ids/views/site-consumption-monitoring-data-test-ids";
import { siteSectionTree } from "@/constants/data-test-ids/views/tools/site-section-tree-data-test-ids";

export const DATA_TEST_IDS = {
  views: {
    consumptionMonitoring,
    dashboard,
    siteConsumptionMonitoring,
    siteSectionTree,
    siteSectionsPlanning,
  },
  components: {
    baseTree,
    categoryCreationForm,
    confirmationDialog,
    consumptionOverviewSites,
    createSiteSectionDrawer,
    dateRangePicker,
    draggableSiteSectionsTree,
    editSiteDetailsDrawer,
    editSiteDetailsForm,
    moveSectionAppliancesWizard,
    planningDateRangeHeaderCell,
    planningDateRangeNavigator,
    planningTodayHeaderCell,
    programEditor,
    programIcon,
    programFormDialog,
    programmingDateRangeInputs,
    programmingRangeFormDialog,
    sectionAppliancesCountByProgrammingCategory,
    sectionAppliancesV2Dialog,
    sectionChildrenProgrammingRangesCountCell,
    sectionDetailsDrawer,
    sectionDetailsReadonlyContent,
    sectionProgrammingRangesCell,
    sectionProgrammingRange,
    selectProgram,
    selectSectionParentDialog,
    siteSectionCategoryDrawer,
    selectSite,
    selectSiteSectionPerimeter,
    simpleSiteSectionsTree,
    siteConsumptionMonitoringSectionCategoryFilter,
    siteDetailsCard,
    siteSectionActiveFilters,
    siteSectionsTreeApplianceCategoryFilter,
    siteSectionsTreeSectionCategoryFilter,
    siteSectionsVirtualizedTable,
    siteTreeStructure,
    tabs,
    userPerimeterTree,
    weeklyProgram,
  },
};
